import { ServiceResult } from '../models/api-shared.models';
import {
  DismissCustomerProductRecommendationRequest,
  GetCustomerProductRecommendationsRequest,
  GetCustomerProductRecommendationsResult,
  UpdateCustomerProductRecommendationRequest,
} from '../models/customer-product-recommendation.models';
import ApiService from './api-service';

class CustomerProductRecommendationService extends ApiService {
  private static classInstance: CustomerProductRecommendationService;

  private constructor() {
    super('CustomerProductRecommendation');
  }

  public getCustomerProductRecommendations(
    request: GetCustomerProductRecommendationsRequest
  ): ServiceResult<GetCustomerProductRecommendationsResult> {
    return this.post(`${this.baseUrl}/GetCustomerProductRecommendations`, request);
  }

  public dismissCustomerProductRecommendation(
    request: DismissCustomerProductRecommendationRequest
  ): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DismissCustomerProductRecommendation`, request);
  }

  public updateCustomerProductRecommendation(
    request: UpdateCustomerProductRecommendationRequest
  ): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/UpdateCustomerProductRecommendation`, request);
  }

  public static getInstance(): CustomerProductRecommendationService {
    if (!CustomerProductRecommendationService.classInstance) {
      CustomerProductRecommendationService.classInstance = new CustomerProductRecommendationService();
    }
    return CustomerProductRecommendationService.classInstance;
  }
}

export default CustomerProductRecommendationService;
